<template>
	<div class="colors-picker">
		<div v-for="color , index in colorsArray" class="is-inline-block position-relative" >
			<input type="radio" :name="name" :value="color.color"  :checked="index==0">
			<label class="is-block color-container">
				<i class="fas fa-square-full is-size-4" :style="{color: color.color}"></i>
			</label>
		</div>
	</div>
</template>
<script>

	export default {
		name: 'ChooseColor',
		props:{
			name:{
				required:true,
				type:String
			},
			colors:{
				required:true,
				type:Array
			}
		},
		data() {
			return {
				colorsArray:null
			}
		},
		created : function() {
			this.colorsArray = this.colors;
		},
		methods: {

		},
	}
</script>
<style lang="scss">
.colors-picker  {
	div{
		&:not(:last-child){
			margin-left: 8px;
		}
	}
	input[type=radio] {
		position: absolute;
		top: 0;
		bottom: 0;
		right: 0;
		left: 0;
		width: 100%;
		height: 100%;
		opacity: 0;
	}
	.color-container{
		line-height: 16px;
		cursor: pointer;
		padding: 2px;
	}
	input[type=radio] + .color-container{
		border:2px solid transparent
	}
	input[type=radio]:checked + .color-container{
		border: 2px solid #facc2f;
	}
}
</style>
